export class CreateCloudAccountDialogData {
    regions?: string[];
    customerId?: string;
}